import PropTypes from "prop-types"
import React from "react"
import { HandleImages } from "../components/functions"
import { Link, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import "../css/home-hero.css"
var timeOut
var timeOutNews

var content = {
  hero: {
    protect: (
      <div>
        <h2>Protect my Organization</h2>
        <p>
          Equip IT and cyber professionals with the skills they need to stop
          persistent threats—because organizational reputation and financial
          wellbeing are at stake.
        </p>
      </div>
    ),
    teach: (
      <div>
        <h2>Teach Cyber Security</h2>
        <p>
          Equip IT and cyber professionals with the skills they need to stop
          persistent threats—because organizational reputation and financial
          wellbeing are at stake.
        </p>
      </div>
    ),
    learn: (
      <div>
        <h2>Learn Cyber Security</h2>
        <p>
          Equip IT and cyber professionals with the skills they need to stop
          persistent threats—because organizational reputation and financial
          wellbeing are at stake.
        </p>
      </div>
    ),
    partner: (
      <div>
        <h2>Partner with us</h2>
        <p>
          Equip IT and cyber professionals with the skills they need to stop
          persistent threats—because organizational reputation and financial
          wellbeing are at stake.
        </p>
      </div>
    ),
  },

  news: {
    news1: {
      image: <HandleImages name={"manLaptop"} />,
      title: "Our commitment during COVID-19",
      text: "We remain dedicated to our mission to help protect...",
      url:"/covid19"
    },
    news2: {
      image: <HandleImages name={"bradleyCam"} />,
      title: "An educator's perspective",
      text: "Distance Learning and Teaching, a Q&A with Dr. Bradley Hayes",
      url:"/blog/an-educators-perspective-the-impacts-of-distance-learning-and-teaching-a-qa-with-dr-bradley-hayes/"
    },
    news3: {
      image: <HandleImages name={"bradleyCam"} />,
      title: "An educator's perspective",
      text: "Distance Learning and Teaching, a Q&A with Dr. Bradley Hayes",
      url:"/blog/an-educators-perspective-the-impacts-of-distance-learning-and-teaching-a-qa-with-dr-bradley-hayes/"
    },
  },

  calendly: {
    text: "Schedule an Information Call",
  },
}

class News extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
    this.state = {
      activeNews: 0,
    }
  }
  handleClick(index) {
    console.log("clickety")
    clearTimeout(timeOut)
    this.setState({
      activeNews: index,
    })

    this.handleActiveNews()
  }

  handleNews() {
    var current = this
    return Object.entries(content.news).map(function (child, index) {
      return (

        child[1].url &&
          (child[1].url.charAt(0) == "/" ? (
         
            
        <div key={index} >
          <Link to={child[1].url}>   {child[1].image}
       <div>   <h4> {child[1].title}</h4>
          <p> {child[1].text}</p> </div>   </Link>
        </div>
          
          ) : (
         
              
        <div key={index} >
       <a href={child[1].url}>     {child[1].image}
       <div> <h4> {child[1].title}</h4>
          <p> {child[1].text}</p></div>   </a>
        </div>
           
          ))







      )
    })
  }

  handleNewsControls() {
    var current = this
    return Object.entries(content.news).map(function (child, index) {
      return (
        <div
          key={index}
          onClick={() => {
            current.handleClick(index)
          }}
         className={index == current.state.activeNews ? "active":undefined}
        ></div>
      )
    })
  }
  handleActiveNews() {
    if (timeOutNews) {
      clearTimeout(timeOutNews)
    }
    timeOutNews = setTimeout(() => {
      if (this.state.activeNews < Object.entries(content.news).length - 1) {
        this.setState({
          activeNews: this.state.activeNews + 1,
        })
      } else {
        this.setState({ activeNews: 0 })
      }
    }, 4000)

    //return timer
  }

  handleClickNext() {
    if (this.state.active >= 2) {
      this.setState({
        active: 0,
      })
    } else {
      clearTimeout(timeOut)
      this.setState({
        active: this.state.active + 1,
      })
    }

    this.handleActive()
  }

  handleClickPrev() {
    if (this.state.active <= 0) {
      this.setState({
        active: 2,
      })
    } else {
      clearTimeout(timeOut)
      this.setState({
        active: this.state.active - 1,
      })
    }
    this.handleActive()
  }

  render() {
    this.handleActiveNews()

    return (
      <div className="news">
        <h3>Latest News</h3>
        <div className="news-wrapper">{this.handleNews()}</div>
        <div className="news-controls">{this.handleNewsControls()}</div>
      </div>
    )
  }
}

class HomeHero extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
    this.state = {
      active: 0,
    }
  }

  handleClickNext() {
    if (this.state.active >= 2) {
      this.setState({
        active: 0,
      })
    } else {
      clearTimeout(timeOut)
      this.setState({
        active: this.state.active + 1,
      })
    }

    this.handleActive()
  }

  handleClickPrev() {
    if (this.state.active <= 0) {
      this.setState({
        active: 2,
      })
    } else {
      clearTimeout(timeOut)
      this.setState({
        active: this.state.active - 1,
      })
    }
    this.handleActive()
  }

  handleActive() {
    if (timeOut) {
      clearTimeout(timeOut)
    }
    timeOut = setTimeout(() => {
      if (this.state.active < 2) {
        // console.log('handleACtive2', this.state.active)
        this.setState({
          active: this.state.active + 1,
        })
      } else {
        this.setState({ active: 0 })
      }
    }, 5000)
  }

  handleTimeOuts() {
    //  this.handleActiveNews();
  }

  componentDidMount() {
    // console.log(this.myRef.current.getBoundingClientRect().left + window.scrollX, this.myRef.current.getBoundingClientRect().top + window.scrollY);
  }

  componentWillUnmount() {}

  render() {
    this.handleActive()
    //  this.handleActiveNews();

    return (
      <div
        className={
          this.state.active === 0
            ? "protect home-hero "
            : this.state.active === 1
            ? "improve home-hero "
            : this.state.active === 2
            ? "teach home-hero "
            : "learn home-hero"
        }
      >
           <a className="partner-link" target="_blank" href="https://marketing.circadence.com/acton/fs/blocks/showLandingPage/a/36273/p/p-00f8/t/page/fm/0">Partner With Us</a>
           <div className="three-col">
          <div className='text-box'>
            <h1>
              What are your
              <br />
              cyber security goals?
            </h1>
            <div>
            <div className="titles">
              <h3 onClick={()=>{this.setState({active:0})}}>Protect</h3>
              <h3 onClick={()=>{this.setState({active:1})}}>Improve</h3>
              <h3 onClick={()=>{this.setState({active:2})}}>Teach</h3>
              <h3 onClick={()=>{this.setState({active:3})}}>Learn</h3>
            </div>
            <div className="goals" ref={this.myRef}>
              <div className={this.state.active === 0 ? "active":undefined}>
                <h2 >Protect my Organization </h2>
                <p>
                  Equip IT and cyber professionals with the skills they need to
                  stop persistent threats—because organizational reputation and
                  financial wellbeing are at stake.
                </p>
                <Link to="/protect/cyber-training-enterprise-readiness">     <button name="Learn More" className="outlined-button">Learn More</button> </Link> 
              </div>
              <div className={this.state.active === 1 ? "active":undefined}>
                <h2>Improve Cyber Security</h2>
                <p>
                Build and practice personal cyber skills to impact the cyber readiness of an organization, improve job performance, and grow career.  
                </p>
              <div  className="student-button"> <Link to="/learn/cyber-security-training-students">    <button name="Learn More" className="outlined-button">Learn More</button> </Link>  <Link to="/learn/cyber-security-training-professionals">    </Link> </div> 
              </div>
              <div className={this.state.active === 2 ? "active":undefined}>
                <h2>Teach Cyber Security</h2>
                <p>
                Enrich my lab environment with hands-on learning exercises that enable students to practice skills. Improve enrollment in cyber security courses.
                </p>
                <Link to="/teach/cyber-security-academic">   <button name="Learn More" className="outlined-button">Learn More</button> </Link> 
              </div>
              <div className={this.state.active === 3 ? "active":undefined}>
                <h2>Learn Cyber Security</h2>
                <p>
                Build and practice cyber skills needed to improve job performance, achieve certifications, and grow my career.
                </p>
              <div  className="student-button"> <Link to="/learn/cyber-security-training-students">    <button name="Learn More" className="outlined-button">Learn More</button> </Link>  <Link to="/learn/cyber-security-training-professionals">    </Link> </div> 
              </div>
              
            </div></div>
          </div>
          
       <div>
           <div className={this.state.active === 0 ? "active persona":"persona"}>
       <HandleImages name={"manProtect"} />
     </div>
     <div className={this.state.active === 1 ? "active persona":"persona"}>
     <HandleImages name={"womanImprove"} />
     </div>
     <div className={this.state.active === 2 ? "active persona":"persona"}>
     <HandleImages name={"womanTeach"} />
     </div>
     <div className={this.state.active === 3 ? "active persona":"persona"}>
     <HandleImages name={"manLearn"} />
     </div>
    
          </div>

          <div>
    
          <News />
  
        </div>
          </div>
   
      </div>
    )
  }
}

export default HomeHero
